import { useEffect } from 'react';
import { withAuthProvider } from '../auth';
import { initTrackingContext, initTracking } from './tracking';

function extractUserTraits(me) {
  return {
    id: me ? me.id || null : null,
    primaryEmail: me ? me.primaryEmail || null : null,
    type: me ? me.type || null : null,
    firstName: me ? me.firstName || null : null,
    lastName: me ? me.lastName || null : null,
    displayName: me ? me.displayName || null : null,
    role: me ? me.role || null : null,
    class: me ? me.class || null : null,
  };
}

const runIdentifyIfTraitsChanged = (me) => {
  if (!me.externalId && !me.id) return false;

  const traits = extractUserTraits(me);
  const storedTraits = JSON.parse(localStorage.getItem('last_identified_traits') || '{}');

  const traitsChanged = JSON.stringify(traits) !== JSON.stringify(storedTraits);

  if (traitsChanged) {
    localStorage.setItem('last_identified_traits', JSON.stringify(traits));
  }

  return traitsChanged;
};

const SegmentWrapper = (allData) => {
  const {isLoggedIn, me, data, hits } = allData;
  useEffect(() => {
    if (typeof window === 'undefined' || !window.analytics) return
    const initTimeout = setTimeout(() => {
      try {
        const userId = me ? me.externalId || me.id : null
        if (isLoggedIn && userId) {
          const previousUserId = sessionStorage.getItem('segment_userId')
            if (runIdentifyIfTraitsChanged(me) || previousUserId !== userId) {
            window.analytics.identify(userId, {
              ...me
            })
            sessionStorage.setItem('segment_userId', userId)
            localStorage.setItem('last_identified_traits', JSON.stringify(extractUserTraits(me)))
          }
        } else if (!isLoggedIn && !userId) {
          sessionStorage.setItem('segment_userId', 'anonymous')
          localStorage.setItem('last_identified_traits', JSON.stringify('{}'))
          window.analytics.reset()
        }

        initTrackingContext({
          user: isLoggedIn && me ? { id: userId, ...me } : null,
          isLoggedIn
        })

        if (data) {
          if (Object.keys(data).length > 0) {
            const expertise = data.memberByUid.expertise.join(' ,');
            window.analytics.track('View Member', {
              page_path: window.location.pathname,
              page_url: window.location.href,
              member_name: data.memberByUid.firstName + ' ' + data.memberByUid.lastName,
              member_title: data.memberByUid.memberClassDescription,
              member_email: data.memberByUid.publicEmail,
              member_facility_name: data.memberByUid.primaryFacility.name,
              member_facility_address: data.memberByUid.primaryFacility.address.address1 + ' ' + data.memberByUid.primaryFacility.address.address2,
              member_facility_city: data.memberByUid.primaryFacility.address.city,
              member_section: data.memberByUid.section.name,
              member_expertise: expertise
            })
          }
        } else if (hits) {
          if (hits.length > 0) {
            window.analytics.track('View Facility', {
              facility_name: hits[0].facility_name,
              facility_city: hits[0].city,
              facility_id: hits[0].facility_id,
              facility_state: hits[0].state_name,
            })
          }
        }

        initTracking();
      } catch (error) {
        console.error('Error initializing tracking:', error)
      }
    }, 3000) // 3 second delay (login)
    
    return () => {
      clearTimeout(initTimeout)
    }

  }, [isLoggedIn, me, data, hits]);

  return null;
};

export default withAuthProvider(SegmentWrapper);
